// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uLCn","field":"styles_field__2Cg8N","fieldCol":"styles_fieldCol__2zgy1","diffCol":"styles_diffCol__1-2ls","diff":"styles_diff__1mbXY"};